<script setup>
import { computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';

const { accountId, currentAccount } = useAccount();
const router = useRouter();

const isRmsPropertiesListingEnabled = computed(
  () => currentAccount.value?.rms_properties_listing === true
);

// The url is per account (super admins set it on "Configurações do cliente"); the
// backend already falls back to the shared RMS deployment when it is blank.
const embedUrl = computed(
  () =>
    isRmsPropertiesListingEnabled.value &&
    currentAccount.value?.rms_properties_listing_url
);

watch(
  currentAccount,
  account => {
    if (account?.id && !isRmsPropertiesListingEnabled.value) {
      router.replace({ name: 'home', params: { accountId: accountId.value } });
    }
  },
  { immediate: true }
);
</script>

<template>
  <div class="flex flex-col w-full h-full bg-n-background">
    <iframe
      v-if="embedUrl"
      :src="embedUrl"
      :title="$t('SIDEBAR.RMS_PROPERTIES')"
      class="w-full h-full border-0"
      allow="clipboard-write"
    />
  </div>
</template>
